
import MatTable from "./MatTable";
import { useMemo, useState, useEffect } from "react";
import { Alert, Flex, Select, Spin, select } from 'antd';
import { inkapi } from "../../middleware/interceptor";

const All = () => {

    const [activeCommentRowId, setActiveCommentRowId] = useState(null);
    const [comment, setComment] = useState('');
    const [rowComments, setRowComments] = useState({});

    const [tableData, setTableData] = useState([]);
    const [editingRowIndex, setEditingRowIndex] = useState(null);
    const [editedRowData, setEditedRowData] = useState({});

    const [Loading, setloading] = useState(false);

    const [options, setoptions] = useState([{ label: "Guided", value: 1, disabled: false }, { label: "DIY", value: 2 }, { label: "Published", value: 3 }, { label: "Print Orders", value: 4 }, { label: "Submitted", value: 5 }])
    const validateRequired = (value) => !!value.length;

    const [ProjManager, setProjManager] = useState([]);
    const [Stage, setStage] = useState([]);


    const Handlestagechange = async (BookId, stage) => {

        console.log(BookId, stage, "BookId")
        let payload = {
            BookId: BookId,
            stage: stage
        }
        await inkapi.post('/api/UpdateStage', payload).then(() => {

            GetDetails();
        })

    }

    const HandleProjchange = async (BookId, Id) => {

        console.log(BookId, Id, "BookId")
        let payload = {
            BookId: BookId,
            Id: Id
        }
        await inkapi.post('/api/update-proj-id', payload).then(() => {

            GetDetails();
        })

    }



    useEffect(() => {
        GetProjManager()
        GetStages();
    }, [])


    const GetProjManager = async () => {
        await inkapi.get('/api/Get_proj_Members').then((res) => {


            const responce = res.data.result;

            let filter = responce.map((items) => ({
                label: items.Name,
                value: items.Id
            }));

            console.log(filter, "responce");

            setProjManager(filter);


        }).catch(() => {
            console.log("");
        })

    }

    const GetStages = async () => {
        await inkapi.get('/api/Get_Stages').then((res) => {


            const responce = res.data.result;

            let filter = responce.map((items) => ({
                label: items.Stage,
                value: items.Id
            }));

            console.log(filter, "responce");

            setStage(filter);


        }).catch(() => {
            console.log("");
        })

    }

    const columns = useMemo(
        () => [
            {
                header: "S.No",
                size: 50,
                // cell: (row ) => row.index + 1
                enableEditing: false,

                Cell: ({ row }) => row.index + 1
            },
            {
                accessorKey: "oppid",
                header: "Opp ID",
                size: 50,
                Cell: ({ cell }) => cell.getValue() || "-",
                enableEditing: false,

            },
            {
                accessorKey: "BookId",
                header: "Book ID",
                size: 50,
                enableEditing: false,


            },
            {
                accessorKey: "AuthorId",
                header: "Author ID",
                size: 50,
                enableEditing: false,

            },
            {
                accessorKey: "Name",
                header: "Name",
                enableEditing: false,
                Cell: ({ row }) =>
                    row.original.Name
            },
            {
                accessorKey: "Title",
                header: "Title",
                Cell: ({ cell }) => cell.getValue() || "-",
                muiEditTextFieldProps: ({ cell, row }) => ({
                    type: 'text',
                    required: true,
                    // error: !!validationErrors?.[cell.id],
                    // helperText: validationErrors?.[cell.id],
                    //store edited user in state to be saved later
                    onBlur: (event) => {

                        setEditedRowData({ ...editedRowData, Title: event.target.value })
                        console.log("evenr", event.target.value);
                        const validationError = !validateRequired(event.currentTarget.value)
                            ? 'Required'
                            : undefined;
                        handleSave(row.original.BookId, event.target.value)
                    },
                }),
            },
            // {
            //   accessorKey: "comments",
            //   header: "Comment",
            //   Cell: ({ row }) => {
            //     const bookId = String(row.original.BookId);
            //     const isEditing = activeCommentRowId == bookId;
            //     // const [comment, setComment] = useState("");

            //     return isEditing ? (
            //       <div style={{ display: "flex", gap: "8px" }}>
            //         <input
            //           type="text"
            //           value={comment || row.original.comments}
            //           placeholder="Add comment"
            //           onChange={(e) => setComment(e.target.value)}
            //           style={{
            //             padding: "2px 8px",
            //             borderRadius: "4px",
            //             border: "1px solid #ccc",
            //           }}
            //         />
            //         <button
            //           onClick={() => { handleSavecomments(bookId, comment); setComment('') }}
            //           style={{
            //             padding: "2px 10px",
            //             backgroundColor: "#007bff",
            //             color: "white",
            //             border: "none",
            //             borderRadius: "4px",
            //             cursor: "pointer",
            //           }}
            //         >
            //           Save
            //         </button>
            //       </div>
            //     ) : row.original.comments == null || row.original.comments == "" ? (
            //       <button
            //         onClick={() => {
            //           setActiveCommentRowId(bookId);
            //           setRowComments((prev) => ({
            //             ...prev,
            //             [bookId]: row.original.comments || "",
            //           }));
            //         }}
            //         style={{
            //           padding: "2px 10px",
            //           backgroundColor: "white",
            //           color: "#444",
            //           border: "1px solid #ccc",
            //           borderRadius: "4px",
            //           cursor: "pointer",
            //         }}
            //       >
            //         Add Comments
            //       </button>
            //     ) : (
            //       row.original.comments
            //     );
            //   },
            // },
            {
                accessorKey: "Edit",
                header: "Stage",
                size: 100,
                Cell: ({ row }) => {
                    // const stage = row.original.stage;

                    // // dynamically disable options based on stage value
                    // const dynamicOptions = [
                    //     { label: "Guided", value: 1, disabled: stage == 1 },
                    //     { label: "DIY", value: 2, disabled: stage == 2 },
                    //     { label: "Published", value: 3, disabled: stage == 3 },
                    //     { label: "Print Orders", value: 4, disabled: stage == 4 },
                    //     { label: "Submitted", value: 5, disabled: stage == 5 },
                    // ];

                    return (
                        <Select
                            value={row.original.stage || null}
                            options={Stage}
                            placeholder="Select Any"
                            onChange={(e) => Handlestagechange(row.original.BookId, e)}
                            style={{ width: 140 }}
                        />
                    );
                }
            },
            {
                accessorKey: "Edit",
                header: "Project Manager",
                size: 100,
                Cell: ({ row }) => {
                    const stage = row.original.stage;


                    return (
                        <Select
                            value={row.original.Proj_Id || null}
                            options={ProjManager}
                            placeholder="Select Any"
                            onChange={(e) => HandleProjchange(row.original.BookId, e)}
                            style={{ width: 140 }}
                        />
                    );
                }
            },


            {
                accessorKey: "package",
                header: "Package",
                size: 100,
                enableEditing: false,
                Cell: ({ cell }) => cell.getValue() || "-",
            },
            {
                accessorKey: "interior",
                header: "Interior",
                enableEditing: false,
                size: 100,
                Cell: ({ cell }) => cell.getValue() || "-",
            },
            {
                accessorKey: "cover",
                header: "Cover",
                enableEditing: false,
                size: 100,
                Cell: ({ cell }) => cell.getValue() || "-",
            },
            {
                accessorKey: "paymentMade",
                header: "Payment Made",
                enableEditing: false,
                size: 50,
                Cell: ({ cell }) => cell.getValue() || "-",
            },
            {
                accessorKey: "paymentPending",
                header: "Payment Pending",
                enableEditing: false,
                size: 50,
                Cell: ({ cell }) => cell.getValue() || "-",
            },

            // {
            //   accessorKey: "status",
            //   header: "Status",
            //   size: 100,
            //   enableEditing: false,
            //   Cell: ({ cell }) => cell.getValue() || "-",
            // },

        ], [ProjManager,Stage]);




    const handleEditRow = (row) => {
        setEditingRowIndex(row.index);
        setEditedRowData(row.original);
    };


    const handleSaveComment = async (rowId, comment) => {
        console.log(rowId, comment, "dataaa")
        try {
            const response = await inkapi.post("/api/savecomment", {
                id: rowId,
                comment: comment,
            });
            if (response.data.success) {
                console.log("Comment saved!");
            }
        } catch (err) {
            console.error("Failed to save comment:", err);
        }
    };

    const handleSave = async (index, title) => {
        try {

            const updatedRow = editedRowData;
            console.log("updatedRow", updatedRow);
            // const [firstName, lastName] = updatedRow.Name.split(" ") || "";
            const payload = {
                BookId: index,
                FirstName: "firstName",
                LastName: "lastName",
                Title: title
            };

            const response = await inkapi.post('/api/editedbookdetails', payload);

            console.log(response.data, "Data")
            if (response.data.message == "Book details updated successfully") {
                const updatedData = [...tableData];
                updatedData[index] = updatedRow;
                // setTableData(updatedData);
                setEditingRowIndex(null);
                setEditedRowData({});
                await GetDetails();
            } else {
                console.error("Failed to save:", response.data.message);
            }
        } catch (err) {
            console.error("API error while saving row:", err);
        }
    };


    const handleSavecomments = async (bookId, comment) => {


        console.log(comment, 'rowComments')
        try {

            const payload = {
                BookId: activeCommentRowId,
                Comments: comment
            };

            const response = await inkapi.post('/api/comments', payload);
            if (response.data.success) {
                setActiveCommentRowId(null);
                setComment('');
                await GetDetails()
            } else {
                console.error("Failed to save:", response.data.message);
            }
        } catch (err) {
            console.error("API error while saving row:", err);
        }
    };



    useEffect(() => {
        GetDetails()
    }, []);



    const GetDetails = async () => {

        setloading(true);
        await inkapi.get(`api/getbookdetails/${"data"}`)
            .then((res) => {
                const result = res.data;
                console.log("API Raw:", res.data.data);
                if (result.success) {
                    const mappedData = result.data.map((item) => ({
                        BookId: item.BookId,
                        AuthorId: item.AuthorId,
                        Name: `${item.FirstName} ${item.LastName}`,
                        Title: item.Title,
                        comments: item.Comment,
                        oppid: item?.Opportunities,
                        status: item.bookStatus,
                        stage: item.stage,
                        Proj_Id: item.Proj_Id,
                    }))

                    setTimeout(() => {
                        setloading(false);
                    }, 1000);
                    console.log(mappedData, "data")
                    setTableData(mappedData);
                }
            })
            .catch((err) => console.error("Failed to fetch package values:", err));
    }

    return (
        <div className="material_wrapper">

            {
                Loading ? (
                    <div>
                        <Spin tip="Loading" size="medium">
                            <MatTable columns={columns} data={tableData} />
                        </Spin>
                    </div>


                ) : (
                    <>
                        <MatTable columns={columns} data={tableData} />

                    </>)
            }

        </div>
    );
};
export default All;
